import React, {forwardRef, useImperativeHandle} from "react";
import { useQueryClient } from 'react-query';

import useCountryNames from "../../../services/settings/useCountries";


const CountryNames = forwardRef((props, ref) => {

  const queryClient = useQueryClient();
  let extraKeys = [props.countryCode];

  const countries = useCountryNames({ queryClient, extraKeys: extraKeys, useCache: true});

  if (countries.data && Array.isArray(countries.data) && countries.data.length > 0) {
    if (props.onChange) {
      if (!props.countryCode) {
        props.onChange({});
      } else {
        const country = {
          ...countries.data[0]
        };
        props.onChange(country);
      }
    }
  }

  return ( <></> );
})

export default CountryNames;
